<template>
  <div class="SpecialGuestWrap contentBox" :class="speciaStyle ? 'mobTwoWrap' : 'normalWrap'">
    <router-link class="index-title" :to="{ path: GuestHref.url, query:{ name: GuestHref.name } }" target="_blank">{{ GuestHref.name }}</router-link>
    <ul class="content">
      <li v-for="(item,index) in GuestData" :key="index" @click="LookGuestInfoFn(index)">
        <div class="guest_imgBox">
          <img :src="item.imagePath" />
          <div class="img_cover"></div>
        </div>
        <p class="guestName">{{ item.name }}</p>
        <p class="guestIntr Linebreak">{{ item.abstract }}</p>
      </li>
    </ul>
    <router-link class="index-more" :to="{ path: GuestHref.url, query:{ name: GuestHref.name } }">更多嘉宾</router-link>
  </div>
</template>

<script>
  export default{
    name: 'IndexSpecialGuest',
    props: {
      GuestData: {
        type: Array,
        default: () => []
      },
      ispc: {
        type: Boolean,
        default: true
      },
      GuestTopicId: {
        type: Number,
        default: 6
      },
      GuestHref: {
        type: Object,
        default: () => {}
      },
      issub: {
        type: Boolean,
        default: false
      },
      speciaStyle: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      // 特邀嘉宾信息
      LookGuestInfoFn(ind) {
        this.$emit('GuestInfoFn',ind);
      },
      // 特邀嘉宾-收起
      PackUpListFn(ind) {
        let boxDom = this.$refs.GuestContent.children[ind],
          contentDom = boxDom.children[1],
          height = contentDom.offsetHeight;
        boxDom.children[0].children[1].style.transform = (!!height) ? 'rotateX(0deg)' : 'rotateX(180deg)';
        if (!!height) {
          contentDom.style.height = height + 'px';
          let f = document.body.offsetHeight; //强制相应dom重绘，使最新的样式得到应用
          contentDom.style.height = '0px';
        } else {
          contentDom.style.height = 'auto';
          height = contentDom.offsetHeight;
          contentDom.style.height = '0';
          let f = document.body.offsetHeight;
          contentDom.style.height = height + 'px';
        }
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .SpecialGuestWrap {
      overflow: hidden;
      width: 1200px;
    }

    .SpecialGuestWrap ul {
      display: flex;
      flex-wrap: wrap;
      margin: 40px 0 15px;
      justify-content: space-between;
      padding-right: 10px;
    }

    .SpecialGuestWrap li {
      width: 208px;
      color: #FFFFFF;
      margin-bottom: 40px;
      cursor: pointer;
    }

    .SpecialGuestWrap li img,
    .img_cover,
    .guest_imgBox {
      width: 100%;
      height: 254px;
    }

    .guest_imgBox {
      position: relative;
    }

    .img_cover {
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba(0, 0, 0, .3);
      z-index: 0;
    }

    .SpecialGuestWrap li img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .SpecialGuestWrap li .guestName {
      font-size: 20px;
      margin: 20px 0 15px;
      text-align: center;
    }

    .SpecialGuestWrap li .guestIntr {
      font-size: 14px;
      line-height: 24px;
      height: 48px;
    }

    .SpecialGuestWrap .index-more {
      margin: 15px auto 95px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .SpecialGuestWrap {
      overflow: hidden;
    }

    .SpecialGuestWrap ul {
      display: flex;
      flex-wrap: wrap;
    }

    .normalWrap li{
      position: relative;
      top: 100vh;
    }


    .SpecialGuestWrap li {
      width: 1.8rem;
      margin-right: .45rem;
      color: #FFFFFF;
      margin-bottom: .4rem;
    }

    .mobTwoWrap li{
      color: #000000;
    }

    .SpecialGuestWrap li:nth-child(3n) {
      margin-right: 0;
    }

    .SpecialGuestWrap li img,
    .img_cover,
    .guest_imgBox {
      width: 100%;
      height: 2.2rem;
    }

    .guest_imgBox {
      position: relative;
    }

    .img_cover {
      position: absolute;
      top: .1rem;
      left: .1rem;
      background: rgba(0, 0, 0, .3);
      z-index: 0;
    }

    .SpecialGuestWrap li img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .SpecialGuestWrap li .guestName {
      font-size: .32rem;
      margin: .2rem 0;
      text-align: center;
    }

    .SpecialGuestWrap li .guestIntr {
      font-size: .24rem;
      line-height: .32rem;
      height: .64rem;
    }

    .SpecialGuestWrap .content {
      margin: 0 auto;
    }
  }

  .SpecialGuestWrap .main_news_active {
    transition: all 1s;
    opacity: 1 !important;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexSpecialGuest.vue